import type { SVGProps } from 'react';
const SvgAddchart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#addchart_svg__a)">
      <path
        fill="currentColor"
        d="M22 5v2h-3v3h-2V7h-3V5h3V2h2v3h3Zm-3 14H5V5h6V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6h-2v6Zm-4-6v4h2v-4h-2Zm-4 4h2V9h-2v8Zm-2 0v-6H7v6h2Z"
      />
    </g>
    <defs>
      <clipPath id="addchart_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAddchart;
